import { render, staticRenderFns } from "./vpnMobile.vue?vue&type=template&id=d86a70cc&scoped=true"
import script from "./vpnMobile.vue?vue&type=script&lang=js"
export * from "./vpnMobile.vue?vue&type=script&lang=js"
import style0 from "./vpnMobile.vue?vue&type=style&index=0&id=d86a70cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86a70cc",
  null
  
)

export default component.exports